<template>
	<div>
    <div class="empty-img2" v-if="data.length==0">
      <img src="./qa.png"/>
      <p>暂无问答</p>
    </div>
		<div class="question">
			<ul class="question-items" v-dt-infinite-scroll="getData">
				<!--<li class="question-item">
					<div class="question-text o2">老师，怎么才能考上重点高中？老师，怎么才能考上重点高中？老师，怎么才能考上重点高中？</div>
					<div class="question-answer o3">老师，怎么才能考上重点高中？老师，怎么才能考上重点高中？老师，怎么才能考上重点高中？</div>
					<div class="question-info f-cb">
						<div class="question-time">更新于2018.08.02</div>
						<div class="question-all">全部3个回答</div>
					</div>
				</li>-->
				<li class="question-item" v-for="item in data">
					<div class="question-text o2">{{item.title}}</div>
					<div class="question-answer o3" v-if="item.answers.length>0">{{item.answers[0].content}}</div>
					<div class="question-info f-cb">
						<div class="question-time">更新于{{tools.timestampConversion(item.create_time)}}</div>
						<div class="question-all" @click="$router.push('/answer/'+item.id)">全部{{item.answers.length}}个回答</div>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				data:[]
			}
		},
    created() {
      //获取导航参数
      function geturl_j2(name){
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      }
      var v_key = geturl_j2('v_key');
      // if (!/Android|webOS|iPhone|iPod|BlackBerry|HarmonyOS/i.test(navigator.userAgent)) {
      //   window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      // }
      // 是不是手机/平板（移动设备）
      const ua = navigator.userAgent || '';
      const isMobile = /Mobile|Android|iPhone|iPod|webOS|BlackBerry|iPad|Tablet/i.test(ua);
      // 如果不是移动设备，才跳PC登录
      if (!isMobile) {
        window.location.href = "/mooc_free_login/video.html?section_id="+ this.$route.params.id +"&course_id="+ this.$route.params.courseId +"&v_key="+ v_key;
      }
    },
    methods:{
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/question_answer/index",
						section_id:this.$route.params.id,
						course_id:this.$route.params.courseId,
						len:5,
						page
					},res=>{
						var data=res.data;
						this.data=this.data.concat(data);
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
					});
				})
			}
		}
	}
</script>

<style>
	.empty{
		padding-top:0.52rem;
		font-size: 0.32rem;
		color:#999;
		text-align: center;
	}
	.question-item{
		padding-top:0.533rem;
		padding-bottom: 0.4rem;
		margin:0 0.4rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.question-item:last-child{
		border-bottom: 0;
	}
	.question-text{
		padding-left: 0.693rem;
		background: url(./ask.png) left 0.12rem no-repeat;
		background-size: 0.426rem;
		font-size: 0.426rem;
		color:#333;
		line-height: 0.64rem;
	}
	.question-text img{
		max-width: 100%!important;
	}
	.question-answer{
		margin-top:0.36rem;
		padding-left: 0.693rem;
		background: url(./answer.png) left 0.04rem no-repeat;
		background-size: 0.426rem;
		font-size: 0.346rem;
		color:#666;
		line-height: 0.506rem;
	}
	.question-info{
		margin-top:0.453rem;
		color:#999;
		font-size: 0.266rem;
	}
	.question-time{
		float:left;
	}
	.question-all{
		float:right;
		padding-right:0.266rem;
		background:url(../me/enter.png) center right no-repeat;
		background-size: 0.133rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/lesson-question/lesson-question.vue